import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona con cesárea?',
    a: 'Sí, movimientos 1/3/5 solo. Espera 6 meses total. Consulta doctor.'
  }, {
    q: '¿Cuánto tiempo/día?',
    a: '12min movimientos + swaps invisibles (no extra tiempo cocinar).'
  }, {
    q: '¿Amamantando OK?',
    a: 'Sí óptimo. Timing post-leche. +200cal leche incluidos.'
  }, {
    q: '¿Familia nota cambios comida?',
    a: 'No: coliflor = arroz vista/sabor.'
  }, {
    q: '¿Peso no baja pero panza sí?',
    a: 'Sí común. Track medidas/fotos.'
  }, {
    q: '¿Diástasis severa?',
    a: 'Mejora 60% 21 días. Fisio si >3cm.'
  }, {
    q: '¿Costo extra?',
    a: '$20-30 swaps supermercado. Sin gym/suplementos.'
  }, {
    q: '¿Garantía resultados?',
    a: 'Depende cumplimiento 90%+. 85% ven -2-5cm.'
  }];
  return <Section className="bg-[#FFF8F0]" data-id="element-21">
      <h2 className="text-3xl md:text-4xl font-bold text-[#0D5C63] mb-12 text-center font-serif" data-id="element-22">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-23">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-24" />)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-25">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-26">
        <span className="font-bold text-[#0D5C63] text-lg" data-id="element-27">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-28">
          <ChevronDown className="w-5 h-5 text-[#C9A84C]" data-id="element-29" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-30">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-31">
            <div className="px-6 pb-4 text-gray-600 border-t border-gray-100 pt-2" data-id="element-32">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}